import { render } from "./bannerModal.vue?vue&type=template&id=327d3742&scoped=true&ts=true"
import script from "./bannerModal.vue?vue&type=script&lang=ts"
export * from "./bannerModal.vue?vue&type=script&lang=ts"

import "./bannerModal.vue?vue&type=style&index=0&id=327d3742&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-327d3742"]])

export default __exports__